module.exports = __webpack_public_path__ + "static/media/projectActiveIcon.9f2f8489.svg";